/**
 * Client
 * This is the main entry point for the browser version of
 * the app.
 */

import App     from './app'
import Browser from './plugins/browser'

const app = new App()

app.addPlugin(Browser, '#app')

app.start(function(error) {
  if (error) {
    console.error(error)
  }
})



/** WEBPACK FOOTER **
 ** ./web/static/app/client.js
 **/